import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtPWD from "./CustomTool/CtTxtPWD";
import CtBtn from "./CustomTool/CtBtn";
import image from "../images/image.png";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Link, useNavigate } from "react-router-dom";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  setMenuPrivileges,
  setMenuPrivilegesToFalse,
} from "../SystemUtility/MenuUtility";
import { fetchUser } from "./API";
import {
  ListAlt,
  Assessment,
  Business,
  Hail,
  Hiking,
  PostAdd,
  AccountCircle,
  ReceiptOutlined,
} from "@mui/icons-material";
import Sign_Up from "./Sign_Up";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import refreshIcon from "../images/refresh.png";
import lineBackground from "../images/images.png";
import { apiURL } from "./API";
// import lineBackground from "../images/CaptchaBackground.png";

const useStyles = (theme) => ({
  card1: {
    // height: "420px",
    // width: "420px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  forget: {
    margin: "10px 0",
    fontWeight: "400",
    color: "#05699d",
    float: "right",
  },
  submit: {
    color: "white",
    backgroundColor: "#05699d",
  },
});

class Login extends Component {
  state = {
    formData: {
      msg: "",
      txtUserId: "",
      txtPassword: "",
      txtCaptcha: "",
    },
    ARD: null,
    captchaText: this.generateCaptcha(),
  };

  //#region Component
  componentDidMount() {
    // this.props.setTitle();
    document.title = "RA : Login";
    this.props.setActiveMenu("/");
    this.clearLocalStorage();
    setMenuPrivilegesToFalse(
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges,
    );
    document.getElementById("txtUserId").focus();
  }
  //#endregion

  //#region Handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  //#endregion

  //#region Function
  setLoginDetailToLocalStorage = (
    logInID,
    UserName,
    bint_ci,
    SubscriptionDays,
  ) => {
    // console.log('logInID, UserName', logInID, UserName)
    this.clearLocalStorage();
    localStorage.setItem("logInID", logInID);
    localStorage.setItem("logInLinkText", "Log Out");
    localStorage.setItem("UserName", UserName);
    localStorage.setItem("CI", bint_ci);
    localStorage.setItem("SubscriptionDays", SubscriptionDays);
  };

  clearLocalStorage = () => {
    localStorage.removeItem("logInID");
    localStorage.removeItem("UserName");
    localStorage.setItem("logInLinkText", "Log In");
    localStorage.removeItem("FullACY");
    localStorage.removeItem("ACY");
    localStorage.removeItem("CompanyName");
    localStorage.removeItem("acid");
    localStorage.removeItem("CompStateCode");
    localStorage.removeItem("CI");
    localStorage.removeItem("defaultsettings");
  };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  validateInput = (index = null) => {
    let result = false;
    if (
      (index === null || index === 0) &&
      this.state.formData.txtUserId.length <= 0
    ) {
      this.props.toastErrorMsg("Enter User ID", "txtUserId");
    } else if (
      (index === null || index === 1) &&
      this.state.formData.txtPassword.length <= 0
    ) {
      this.props.toastErrorMsg("Enter Password", "txtPassword");
    } else if (this.state.formData.txtCaptcha.length <= 0) {
      this.props.toastErrorMsg("Enter CAPTCHA", "txtCaptcha");
    } else if (this.state.formData.txtCaptcha !== this.state.captchaText) {
      this.props.toastErrorMsg("Enter Valid CAPTCHA");
      this.clearInfo();
    } else {
      result = true;
    }
    return result;
  };

  clearInfo = () => {
    this.setState({
      captchaText: this.generateCaptcha(),
      formData: {
        ...this.state.formData,
        // txtUserId: "",
        // txtPassword: "",
        txtCaptcha: "",
      },
    });
    document.getElementById("txtCaptcha").focus();
  };

  refreshCaptcha = () => {
    this.setState({
      captchaText: this.generateCaptcha(),
      formData: { ...this.state.formData, txtCaptcha: "" },
    });
  };

  generateCaptcha(type = "numeric", length = 6) {
    const chars =
      type === "alphanumeric"
        ? "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
        : "0123456789";
    return Array.from(
      { length },
      () => chars[Math.floor(Math.random() * chars.length)],
    ).join("");
  }

  verifyLogin = () => {
    if (this.validateInput()) {
      this.props.notifyProcessing();

      const reqData = {
        Op: "VerifyUser",
        vac_userid: this.state.formData.txtUserId,
        vac_password: this.state.formData.txtPassword,
      };
      fetchUser(reqData)
        .then((res) => {
          this.setState({ res: res.data });
          this.props.closeUpdateProcessing();
          if (res.data.msgType == "error") {
            let msg = res.data.message;
            this.setState({
              formData: {
                ...this.state.formData,
                msg,
              },
            });
          }

          // console.log(this.state.res);
          if (res.data.msgType === "success") {
            this.setLoginDetailToLocalStorage(
              this.state.formData.txtUserId,
              res.data.vac_username,
              res.data.bint_ci,
              res.data.SubscriptionDays,
            );
            if (res.data.vac_privileges && res.data.vac_privileges.length > 0) {
              // console.log("this.props",this.props);
              setMenuPrivileges(
                res.data.vac_privileges,
                this.props.setSubMenu_Master_Entry,
                this.props.setUserPrivileges,
              );
            }
            this.navigateTo("Dashboard");
          }
          // set local storage of UserType, USerID.
        })
        .catch((err) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occured in VerifyUser.\n\n" + err,
          );
        });
    }
  };

  OnSingup = () => {
    // console.log("faizan");
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // labelAgree='Set'
          // alertMessage={<SignUp />}
          alertMessage={<Sign_Up />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD }, () => {});
    });
  };

  OnForgotPassword = () => {
    this.props.toastErrorMsg("Development Remain..");
  };
  //#endregion Function

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Grid
          className={classes.root}
          container
          display="flex"
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          height={"auto"}
          // minheight="90vh"
          // spacing={2}
        >
          {/* <Grid item sx="auto" display="flex" justifyContent="space-between" flexDirection="row"> */}
          <Grid item xs={12} md={8}></Grid>
          <Grid item xs={12} md={4}>
            <Container className={classes.root}>
              <Card
                className={classes.card1}
                style={{
                  // background: "#05699d"
                  // height: "80vh",
                  height: "auto",
                  // width: "420px",
                }}
              >
                <CardContent>
                  <Typography
                    fontSize="30px"
                    display="flex"
                    justifyContent="flex-start"
                    fontWeight="600"
                    color="#05699d"
                    // marginBottom="20px"
                  >
                    Welcome Back!
                  </Typography>
                  <Typography
                    fontSize="18px"
                    display="flex"
                    justifyContent="flex-start"
                    fontWeight="300"
                    color="#575759"
                    marginBottom="20px"
                  >
                    Login to continue
                  </Typography>
                  <form>
                    <CtTxt
                      id="txtUserId"
                      label="User ID"
                      variant="outlined"
                      handleOnChange={this.handleOnChange}
                      value={this.state.formData.txtUserId}
                      fullWidth={true}
                      onKeyDown={this.props.onKeyDown}
                      maxLength="50"
                    />
                    <CtTxtPWD
                      id="txtPassword"
                      label="Password"
                      variant="outlined"
                      handleOnChange={this.handleOnChange}
                      value={this.state.formData.txtPassword}
                      type="password"
                      fullWidth={true}
                      formcontrolStyle={{ marginTop: "20px" }}
                      onKeyDown={this.props.onKeyDown}
                      // defaultAction={this.verifyLogin}
                      // validateInput={this.validateInput}
                      maxLength="50"
                    />

                    <Grid
                      container
                      alignItems="center"
                      spacing={1}
                      marginTop={1}
                    >
                      <Grid item>
                        <CtTxt
                          id="txtCaptcha"
                          label="Enter CAPTCHA"
                          variant="outlined"
                          handleOnChange={this.handleOnChange}
                          value={this.state.formData.txtCaptcha}
                          // fullWidth={true}
                          width={150}
                          onKeyDown={this.props.onKeyDown}
                          defaultAction={this.verifyLogin}
                          maxLength="6"
                        />
                      </Grid>
                      <Grid item>
                        <Typography
                          // style={{
                          //   fontSize: "31px",
                          //   fontWeight: "bold",
                          //   letterSpacing: "2px",
                          //   // backgroundColor: "#f0f0f0",
                          //   backgroundImage: `url(${lineBackground})`,
                          //   padding: "5px 10px",
                          //   display: "inline-block",
                          //   borderRadius: "5px",
                          //   textAlign: "center",
                          //   // color: "#1b75bc",
                          //   // color: "#9e9e9e",
                          //   color: "#616161",
                          //   // fontFamily: "Comic Sans MS",
                          //   width: "130px",
                          //   fontFamily: "Courier New",
                          // }}

                          style={{
                            fontSize: "34px",
                            fontWeight: "bold",
                            letterSpacing: "5px",
                            backgroundImage: `url(${lineBackground})`, // your background grid image
                            padding: "2px 10px",
                            display: "inline-block",
                            borderRadius: "5px",
                            textAlign: "center",
                            color: "#6e6e6eff",
                            fontFamily: "Courier New, monospace",
                            textShadow: "2px 2px 2px rgba(0,0,0,0.1)",
                            backgroundRepeat: "repeat",
                            // transform: "skew(-10deg)",
                            border: "1px solid #ccc",
                            width: "150px",
                            position: "relative",
                            userSelect: "none", // Disable text selection
                            pointerEvents: "none", // Disable mouse events (optional)
                          }}
                        >
                          {this.state.captchaText}
                          <span
                            style={{
                              content: "''",
                              position: "absolute",
                              top: "40%",
                              left: 0,
                              width: "100%",
                              height: "3px",
                              backgroundColor: "red",
                              transform: "rotate(-5deg)",
                            }}
                          />
                        </Typography>
                      </Grid>
                      <Grid item>
                        <button
                          type="button"
                          onClick={this.refreshCaptcha}
                          style={{
                            cursor: "pointer",
                            background: "none",
                            border: "none",
                          }}
                        >
                          <img
                            src={refreshIcon}
                            alt="logo"
                            width={"25px"}
                            height={"25px"}
                          />
                        </button>
                      </Grid>
                    </Grid>

                    {this.state.formData.msg && (
                      <Typography
                        fontSize="15px"
                        display="flex"
                        justifyContent="flex-start"
                        fontWeight="300"
                        color="#ff000dff"
                        marginTop={2}
                      >
                        {this.state.formData.msg}
                      </Typography>
                    )}
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={2}
                      marginTop={0}
                    >
                      <Grid item>
                        <CtBtn
                          variant="contained"
                          //   className={classes.submit}
                          width="auto"
                          onClick={this.verifyLogin}
                          label="Login"
                          bgColor="#05699d"
                        />
                      </Grid>
                      {/* <Grid item>
                        <CtBtn
                          variant="contained"
                          width="auto"
                          label="Sign Up"
                          bgColor="#05699d"
                          onClick={this.OnSingup}
                        />
                      </Grid> */}
                      <Grid item>
                        <CtBtn
                          variant="text"
                          label="Forgot Password?"
                          fontColor="#05699d"
                          // className={classes.forget}
                          //   onClick={() => this.navigateTo("Forgotpass")}
                          onClick={this.OnForgotPassword}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      // marginTop={2}
                      // spacing={2}
                    >
                      <Grid item>
                        <Typography
                          fontSize="15px"
                          display="flex"
                          justifyContent="center"
                          fontWeight="300"
                          color="#575759"
                          marginTop="5px"
                        >
                          Copyright @ 2023
                        </Typography>
                        <Typography
                          fontSize="15px"
                          display="flex"
                          justifyContent="center"
                          fontWeight="300"
                          color="#575759"
                          marginBottom="15px"
                        >
                          <span style={{ marginRight: "4px" }}>
                            Developed By
                          </span>
                          {/* Developed By{" "} */}
                          <a
                            href="https://ravitechworld.com/"
                            underline="hover"
                            target="_blank"
                          >
                            Ravi Tech World
                          </a>
                        </Typography>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Container>
          </Grid>
          {/* </Grid> */}
          <Grid item>
            <Box
              display={{ xs: "none" }}
              style={{ textAlign: "center", justifyContent: "center" }}
            >
              {this.state.ARD}
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  }
}
function WithNavigate(props) {
  let navigate = useNavigate();
  return <Login {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(withStyles(useStyles)(HoCtToastContainer(WithNavigate)));
